import {ChangeDetectionStrategy, Component, computed, input, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FetteinheitenRechnerZeile} from '../../data/fetteinheiten-rechner-zeile';

interface FetteinheitenRechnerZeileResult {
  zeile: FetteinheitenRechnerZeile,
  result: number;
}

import { NumberInputComponent } from '@softline/ui-core';
@Component({
  selector: 'soft-fetteinheiten-kalkulator',
  imports: [CommonModule,
    NumberInputComponent],
  templateUrl: './fetteinheiten-kalkulator.component.html',
  styleUrl: './fetteinheiten-kalkulator.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FetteinheitenKalkulatorComponent {

  title = input<string | null>(null);
  zeilen = input.required<FetteinheitenRechnerZeile[]>();

  readonly inputValues = signal<Record<string, FetteinheitenRechnerZeile>>({});

  readonly calculatedZeilen = computed<(FetteinheitenRechnerZeileResult & { index: number })[]>(() => {
    const zeilen = this.zeilen();
    const inputValues = this.inputValues();

    return zeilen.map((zeile, index) => {
      const calculatedZeile = {
        ...zeile,
        kg: inputValues[index]?.kg ?? zeile?.kg ?? null,
        fetteinheitenProz: inputValues[index]?.fetteinheitenProz ?? zeile?.fetteinheitenProz ?? null };

      return {
        index: index,
        zeile: calculatedZeile,
        result: calculatedZeile.kg * ((calculatedZeile.fetteinheitenProz || 0) / 100)
      }
    });
  });

  readonly sum = computed(() => {
    return this.calculatedZeilen().reduce((sum, curr) => sum + curr.result, 0);
  });

  updateZeile(zeile: FetteinheitenRechnerZeile, property: keyof FetteinheitenRechnerZeile, index: number, value?: number | null): void {
    const inputValues = {
      ...this.inputValues()
    };

    if (inputValues[index]?.[property] === value)
      return;

    inputValues[index] = {
      ...zeile,
      [property]: value
    }

    this.inputValues.set(inputValues);
  }
}
